<template>
    <div>
        <div
                v-for="(day, dayIndex) of groupedByDay"
                :key="`meetings-day-${dayIndex}`"
        >
            <div class="bg-whitesmoke py-1">
                <h5 class="text-right mr-1 my-0">{{day.date}}</h5>
            </div>
            <meeting-by-day-detail
                    class="p-2"
                    v-for="(meeting, index) of day.meetings"
                    :key="`meeting-${index}`"
                    :id="`meeting-${meeting.id}`"
                    :meeting="meeting"
            />
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import MeetingByDayDetail from "./Detail";

    export default {
        name: 'meeting-byDay-list',
        components: {MeetingByDayDetail},
        data: () => ({
            moment
        }),
        props: {
            meetings: Array
        },
        computed: {
            groupedByDay() {
                const meetings = {}
                for (const meeting of this.meetings) {
                    const date = moment(meeting.dateheure.date).format('MM/DD/YYYY')
                    meetings[date] ?
                        meetings[date].meetings.push(meeting)
                        :
                        meetings[date] = {
                            date: moment(meeting.dateheure.date).calendar(),
                            meetings: [
                                meeting
                            ]
                        }
                }
                return meetings
            }
        }
    }
</script>
